import script from "./language-proficency.vue?vue&type=script&setup=true&lang=js"
export * from "./language-proficency.vue?vue&type=script&setup=true&lang=js"

import "./language-proficency.vue?vue&type=style&index=0&id=6b159ee8&lang=scss"

const __exports__ = script;

export default __exports__